import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ResourcesComponent } from './resources/resources.component';
import { ResourceRoutingModule } from './resource-routing.module';
import { AppPushAsideContentModule } from '../app-push-aside-content/app-push-aside-content.module';
import { AppLeftNavModule } from '../app-left-nav/app-left-nav.module';
import { AppBannerMsgModule } from '../app-banner-msg/app-banner-msg.module';
import { AppHeaderModule } from '../app-header/app-header.module';

@NgModule({
  imports: [
    CommonModule,
    ResourceRoutingModule,
    AppPushAsideContentModule,
    AppLeftNavModule,
    AppBannerMsgModule,
    AppHeaderModule
  ],
  declarations: [
    ResourcesComponent
  ]
})

export class ResourcesModule { }
